import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NzInputModule} from 'ng-zorro-antd/input';
import {FormsModule} from '@angular/forms';
import {GnPasswordComponent} from './password.component';
import {NzIconModule} from "ng-zorro-antd/icon";


@NgModule({
  declarations: [GnPasswordComponent],
  exports: [GnPasswordComponent],
  imports: [
    CommonModule,
    NzInputModule,
    FormsModule,
    NzIconModule
  ],
  entryComponents: []
})
export class GnPasswordModule {
}
